module.exports = __webpack_public_path__ + "static/img/PrincSecretaryLab.9e977db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PrincSecretaryLab.jpg
// module id = sODT
// module chunks = 0